<template lang="html">

  <div class="oleoturismo">

    <section class="banner-intro animation full-view-intro -middle column-center" data="oleoturismo">

      <h1 class="title -intro">{{$t('vistas.oleoturismo')}}</h1>

      <h2 class="subtitle-intro"><router-link :to="$t('enlaces.vive_aldonza')">{{$t('vistas.vive_aldonza')}}</router-link></h2>

    </section>

    <section class="intro-experiencias animation">

      <router-link :to="$t('enlaces.vive_aldonza')+'#'+$t('banners_experiencia.oleoturismo.id')" class="back">{{$t('volver')}}</router-link>

      <h2 class="title -xs -xxs container">{{$t('banners_experiencia.oleoturismo.titulo_intro_experiencia')}}</h2>

    </section>

    <section class="new-texto-imagen row-center ais animation">

      <div class="textos -small column-center">
        <h3 class="title -xs">{{$t('banners_experiencia.oleoturismo.titulo_catas')}}</h3>
        <div v-html="$t('banners_experiencia.oleoturismo.cuerpo_catas')"></div>
         <p style="justify-content: center; display: flex;"><a class="imagen-trip" target="_blank" href="https://www.tripadvisor.es/Attraction_Review-g1437533-d15780377-Reviews-Bodegas_Aldonza-Munera_Province_of_Albacete_Castile_La_Mancha.html">
          <img src="/static/img/tripadvisor-blanco.png" alt="" class="tripadvisor">
        </a></p>
      </div>
      <div class="contenedor-imagen">
        <img src="/static/img/oleoturismo/imagen-catas.jpg" alt="Imagen de catas">
      </div>

    </section>


    <div class="contenedor-banner-catas animation">

      <las-catas></las-catas>

    </div>

    <section class="contenedor-formulario animation">
      <formulario-experiencias where="oleoturismo"></formulario-experiencias>
    </section>

    <div class="contenedor-banner-localizaciones animation">

      <banner-localizaciones></banner-localizaciones>

    </div>
    
    <div class="contenedor-otras-experiencias animation">
      <otras-experiencias></otras-experiencias>
    </div>

  </div>

</template>

<script lang="js">

  import otrasExperiencias from '@/components/parts/otras-experiencias';

  import lasCatas from '@/components/views/experiencias/las-catas';

  import formularioExperiencias from '@/components/views/experiencias/formulario-experiencias';

  import bannerLocalizaciones from '@/components/views/experiencias/banner-localizaciones'


  export default  {
    name: 'oleoturismo',
    components : {
      'otras-experiencias' : otrasExperiencias,
      'las-catas' : lasCatas,
      'formulario-experiencias' : formularioExperiencias,
      'banner-localizaciones' : bannerLocalizaciones
    },
  }
</script>

<style scoped lang="scss">

  @import "@/assets/css/colors.scss";

  .oleoturismo{
    background: $mud-brown;
  }

  .full-view-intro[data=oleoturismo]{
    background: url("/static/img/oleoturismo/background-intro-oleoturismo.jpg") center/cover no-repeat;
  }
.column-center{
  display:flex;
  align-items: flex-start;
}
  .title.-intro{
    overflow: visible;
    height: auto;
  }

  .intro-experiencias{
    background: $mud-brown;
    position: relative;
  }

  .intro-experiencias .title{
    text-align: center;
  }


.new-texto-imagen{
  padding-bottom: 0;
}
.tripadvisor{
    width: 60px;
    padding-top:30px;
    float:center !important;
  }
  .imagen-trip{
    float: center !important;
  }
  .contenedor-formulario{
    background: url("/static/img/oleoturismo/background-formulario.jpg") center/cover no-repeat;
    display: inline-block;
    width: 100%;
    margin-top: 100px;
  }

  .intro-experiencias{
    padding-bottom: 0;
  }

  .launched{
    .contenedor-imagen{
      opacity: 1;
      transform: translateY(0px);
    }
  }

  @media screen and (max-width: 1100px){

    .new-texto-imagen{
      padding-top: 50px;
      padding-bottom: 100px;
    }
    .new-texto-imagen .textos{
      transform: translateY(0);
      margin-top: 50px;
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/views/experiencias/oleoturismo.vue